import './controllers/diff-contacts-modal-controller';

import template from './component.tpl.html';
import diffModalTemplate from './views/diff-contacts-modal.tpl.html';

class ContactDuplicatesNoticeController {
    constructor($scope, $state, $http, $uibModal, SweetAlert) {
        this.state = $state;
        this.scope = $scope;
        this.api = $http;
        this.modal = $uibModal;
        this.sweetAlert = SweetAlert;

        this.loading = true;
        this.showComponent = false;
        this.possibleDuplicates = [];
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.contact;
        }, () => {
            if (this.contact) {
                this._updateDuplicationInformation();
            }
        })
    }

    _updateDuplicationInformation() {
        this.loading = true;
        this.showComponent = false;
        this.possibleDuplicates = [];

        if (this.contact.hide_duplicate_information) {
            return;
        }

        if (this.contact.preferred_email) {
            this.api.post('fp/contacts', {
                fields: [
                    'id',
                    'cnr_full_name_co'
                ],
                filters: [
                    {
                        field: 'preferred_email',
                        operator: '=',
                        value: this.contact.preferred_email
                    },
                    {
                        field: 'id',
                        operator: '!=',
                        value: this.contact.id
                    }
                ]
            }).then((resp) => {
                const response = resp.data;
                if (response.data.length > 0) {
                    this.possibleDuplicates = response.data;
                    this.loading = false;
                    this.showComponent = true;
                }
            });
        }
    }

    showDiffModal(contactToDiff) {
        this.modal.open({
            controller: 'DiffContactsModalController',
            controllerAs: 'vm',
            templateUrl: diffModalTemplate,
            size: 'lg',
            resolve: {
                contact1Id: () => {
                    return this.contact.id;
                },
                contact2Id: () => {
                    return contactToDiff.id;
                }
            }
        }).result.then(() => {
            this.showComponent = false;
            this.sweetAlert.success('Success', 'Contacts have been merged');
            if (this.onMerge) {
                this.onMerge();
            }
        }, (e) => {
            console.error('merge failed', e);
        });
    }

    hideDuplicateInfoForContact() {
        this.api.put(`contacts/${this.contact.id}/hide-duplicate-info`).then(() => {
            this.showComponent = false;
        });
    }
}

ContactDuplicatesNoticeController.$inject = [
    '$scope',
    '$state',
    '$http',
    '$uibModal',
    'SweetAlert'
];

angular
    .module('festzelt-os.components')
    .component('contactDuplicateNotice', {
        bindings: {
            contact: '<',
            onMerge: '&'
        },
        controller: ContactDuplicatesNoticeController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/contact-duplicate-notice/component.js